import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  personCount: [],
});

const { Types, Creators } = createActions({
  getPersonCountRequest: ['customerId', 'sites'],
  getPersonCountRequestSuccess: ['personCount'],
  getPersonCountRequestFailure: ['errorMessage'],
  resetPersonCount: null,
});

export const getPersonCountRequest = (state) => state.merge({ isLoading: true, errorMessage: null });
export const getPersonCountRequestSuccess = (state, { personCount }) => state.merge({ isLoading: false, personCount });
export const getPersonCountRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });
export const resetPersonCount = (state) => state.merge({ personCount: [] });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PERSON_COUNT_REQUEST]: getPersonCountRequest,
  [Types.GET_PERSON_COUNT_REQUEST_SUCCESS]: getPersonCountRequestSuccess,
  [Types.GET_PERSON_COUNT_REQUEST_FAILURE]: getPersonCountRequestFailure,
  [Types.RESET_PERSON_COUNT]: resetPersonCount,
});

export const PersonCountTypes = Types;
export default Creators;
